export const MANUAL_TRANSACTION_TYPES = [
    // { name: 'Purchase', transactionTypeId: 1 }, //purchaseValue
    // { name: 'Purchase Reversal', transactionTypeId: -1 }, //purchaseValue
    // { name: 'Purchase Redemption', transactionTypeId: 2 }, //purchaseValue
    // { name: 'Purchase Redemption Reversal', transactionTypeId: -2 }, //purchaseValue
    // { name: 'Loyalty Redemption', transactionTypeId: 80 }, //loyaltyValue
    // { name: 'Loyalty Redemption Reversal', transactionTypeId: -81 }, //loyaltyValue
    // { name: 'Loyalty Allocation', transactionTypeId: 21 }, //loyaltyValue
    // { name: 'Loyalty Allocation Reversal', transactionTypeId: 31 }, //loyaltyValue
    { name: 'iCash Topup', transactionTypeId: 9 }, //creditValue
    // { name: 'iCash Topup Reversal', transactionTypeId: -9 }, //creditValue
    // { name: 'iCash Redemption', transactionTypeId: 4 }, //creditValue
    // { name: 'iCash Redemption Reversal', transactionTypeId: -4 }, //creditValue
    // { name: 'iCash Donation', transactionTypeId: 24 }, //creditValue
    // { name: 'iCash Donatsion Refund', transactionTypeId: 34 }, //creditValue
    { name: 'Credit Allocation', transactionTypeId: 20 }, //creditValue
    // { name: 'Credit Allocation Refund', transactionTypeId: 30 }, //creditValue
]